import {Column} from 'commons/models/components/EfeTableValues';
import {SecurityUsers, ClientDataResponse} from 'commons/models/dtos';

export const USERS: Array<Column> = [
    {
        columnDef: 'name',
        header: 'Nombre',
        headerType: 'text',
        cell: (user: SecurityUsers) => user.name,
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'lastName',
        header: 'Primer apellido',
        headerType: 'text',
        cell: (user: SecurityUsers) => (user.lastName ? user.lastName : ''),
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'secondLastName',
        header: 'Segundo Apellido',
        headerType: 'text',
        cell: (user: SecurityUsers) => (user.secondLastName ? user.secondLastName : ''),
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'username',
        header: 'Usuario',
        headerType: 'text',
        cell: (user: SecurityUsers) => user.username,
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'status',
        header: 'Estatus',
        headerType: 'text',
        cell: (user: SecurityUsers) => `${user.status === 'A' ? 'Activo' : 'Inactivo'}`,
        cellType: 'text',
        status: false,
        minWidth: true,
    },
];

export const ADMIN_USERS: Array<Column> = [
    {
        columnDef: 'fullName',
        header: 'Usuario',
        headerType: 'text',
        cell: (user: ClientDataResponse) => user.fullName,
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'fullNameDesc',
        header: 'Nombre / Raz\u00F3n social',
        headerType: 'text',
        cell: (user: ClientDataResponse) => user.fullNameDesc,
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'email',
        header: 'Correo electr\u00F3nico',
        headerType: 'text',
        cell: (user: ClientDataResponse) => user.email,
        cellType: 'text',
        status: false,
        minWidth: true,
    },
    {
        columnDef: 'action',
        header: 'Seleccionar',
        headerType: 'text',
        cell: (user: ClientDataResponse) => user,
        cellType: 'action',
        actionDescription: 'Ver',
        status: false,
        minWidth: true,
    },
];
